import React from 'react';

export const Select = ({ value, onValueChange, required, disabled, children }) => {
  const handleChange = (e) => {
    if (onValueChange && typeof onValueChange === 'function') {
      onValueChange(e.target.value);
    }
  };

  return (
    <select
      value={value}
      onChange={handleChange}
      required={required}
      disabled={disabled}
      className="select"
    >
      {children}
    </select>
  );
};

export const SelectTrigger = ({ children }) => {
  return <>{children}</>;
};

export const SelectValue = ({ placeholder }) => {
  return <option value="" disabled>{placeholder}</option>;
};

export const SelectContent = ({ children }) => {
  return <>{children}</>;
};

export const SelectItem = ({ value, children }) => {
  return <option value={value}>{children}</option>;
};
